import React from 'react'
import AppBar from '../../components/AppBar'
import { I18n } from 'react-redux-i18n'
import CheckInTypePanel from './CheckInTypePanel'
import CheckInTypeResult from './CheckInTypeResult'
import CheckInTypeError from './CheckInTypeError'
import CheckInFormContainer from './CheckInFormContainer'
import ExtraPrivilegeDialog from './ExtraPrivilegeDialog'
import ReservationInfoDialog from './ReservationInfoDialog'

class CheckInScene extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeDialog: null,
      showExtraPrivilege: false,
      showReservationInfo: false,
    }
  }

  handleMenuClick = (menuType) => {
    this.setState({ activeDialog: menuType })
  }

  handleCloseDialog = () => {
    this.setState({ activeDialog: null })
  }

  handleShowExtraPrivilege = () => {
    this.setState({ showExtraPrivilege: true })
  }

  handleCloseExtraPrivilege = () => {
    this.setState({ showExtraPrivilege: false })
  }

  handleShowReservationInfo = () => {
    this.setState({ showReservationInfo: true })
  }

  handleCloseReservationInfo = () => {
    this.setState({ showReservationInfo: false })
  }

  render() {
    const {
      serviceDisplayName,
      serviceName,
      stationName,
      onSubmit,
      onClearForm,
      isSubmitting,
    } = this.props
    const { activeDialog, showExtraPrivilege, showReservationInfo } = this.state

    return (
      <div className="min-h-screen bg-gray-50">
        <AppBar
          header={serviceName.toUpperCase()}
          subHeader={`${I18n.t('checkInScene.title')} (${stationName} - ${serviceDisplayName})`}
          hasBtnGroup
        />

        <div className="pt-20">
          <div className="md:hidden sticky top-20 z-40 bg-white shadow-md">
            <div className="flex divide-x border-b">
              <button
                onClick={() => this.handleMenuClick('reservation')}
                className="flex-1 px-3 py-3 text-xs font-medium text-gray-700 hover:bg-gray-50 active:bg-gray-100"
              >
                Reservation
              </button>
              <button
                onClick={() => this.handleMenuClick('airline')}
                className="flex-1 px-3 py-3 text-xs font-medium text-gray-700 hover:bg-gray-50 active:bg-gray-100"
              >
                Airline
              </button>
              <button
                onClick={() => this.handleMenuClick('walkin')}
                className="flex-1 px-3 py-3 text-xs font-medium text-gray-700 hover:bg-gray-50 active:bg-gray-100"
              >
                Walkin
              </button>
              <button
                onClick={this.handleShowExtraPrivilege}
                className="flex-1 px-3 py-3 text-xs font-medium text-gray-700 hover:bg-gray-50 active:bg-gray-100"
              >
                Extra
              </button>
            </div>
          </div>

          <div className="flex">
            <aside className="hidden md:flex flex-col w-20 sticky top-20 h-[calc(100vh-5rem)] bg-white shadow-md border-r border-gray-200">
              <nav className="flex flex-col items-center py-4 space-y-4">
                <button
                  onClick={() => this.handleMenuClick('reservation')}
                  className="flex flex-col items-center justify-center w-16 h-16 rounded-lg text-gray-600 hover:bg-gray-100 hover:text-primary-600 active:bg-gray-200 transition-colors group"
                  title="Find Reservation"
                >
                  <svg
                    className="w-8 h-8"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
                    />
                  </svg>
                  <span className="text-xs mt-1 text-center leading-tight">
                    Reserv.
                  </span>
                </button>
                <button
                  onClick={() => this.handleMenuClick('airline')}
                  className="flex flex-col items-center justify-center w-16 h-16 rounded-lg text-gray-600 hover:bg-gray-100 hover:text-primary-600 active:bg-gray-200 transition-colors group"
                  title="Airline"
                >
                  <svg
                    className="w-8 h-8"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
                    />
                  </svg>
                  <span className="text-xs mt-1">Airline</span>
                </button>
                <button
                  onClick={() => this.handleMenuClick('walkin')}
                  className="flex flex-col items-center justify-center w-16 h-16 rounded-lg text-gray-600 hover:bg-gray-100 hover:text-primary-600 active:bg-gray-200 transition-colors group"
                  title="Walkin"
                >
                  <svg
                    className="w-8 h-8"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                    />
                  </svg>
                  <span className="text-xs mt-1">Walkin</span>
                </button>
                <button
                  onClick={this.handleShowExtraPrivilege}
                  className="flex flex-col items-center justify-center w-16 h-16 rounded-lg text-gray-600 hover:bg-gray-100 hover:text-primary-600 active:bg-gray-200 transition-colors group"
                  title="Extra Privileges"
                >
                  <svg
                    className="w-8 h-8"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                    />
                  </svg>
                  <span className="text-xs mt-1">Extra</span>
                </button>
              </nav>
            </aside>

            <main className="flex-1 p-4 md:p-6 pb-32">
              <div className="max-w-6xl mx-auto space-y-4">
                <CheckInTypeResult
                  onShowReservationInfo={this.handleShowReservationInfo}
                />
                <CheckInTypeError />
                <CheckInFormContainer
                  onSubmit={onSubmit}
                  onClearForm={onClearForm}
                  isSubmitting={isSubmitting}
                />
              </div>
            </main>
          </div>
        </div>

        <CheckInTypePanel
          activeDialog={activeDialog}
          onClose={this.handleCloseDialog}
          onSubmit={onSubmit}
        />

        <ExtraPrivilegeDialog
          isShow={showExtraPrivilege}
          onClose={this.handleCloseExtraPrivilege}
        />

        <ReservationInfoDialog
          isShow={showReservationInfo}
          onClose={this.handleCloseReservationInfo}
        />
      </div>
    )
  }
}

export default CheckInScene
